export default "__VITE_ASSET__88c8249c__"